import script from "./Slider.vue?vue&type=script&setup=true&lang=ts"
export * from "./Slider.vue?vue&type=script&setup=true&lang=ts"

import "./Slider.vue?vue&type=style&index=0&id=220168ef&lang=scss"

const __exports__ = script;

export default __exports__